
// src/Pages/DistrictBDPOReport.jsx - UPDATED VERSION
import { useState, useEffect } from "react";
import {
    Button,
    Table,
    Spin,
    Alert,
    message,
    Modal,
    Space
} from "antd";
import {
    FileExcelOutlined,
    ReloadOutlined,
    FilePdfOutlined,
} from "@ant-design/icons";
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import * as XLSX from "xlsx";
import {
    getBdpoBlockSpecialGsReport,
    getAdminGpSummaryReport
} from "../api/User";

const DistrictBDPOReport = ({ dateFilter }) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [gpCurrentPage, setGpCurrentPage] = useState(1);
    const [gpPageSize, setGpPageSize] = useState(10);

    /* -------- GP Modal -------- */
    const [gpModalOpen, setGpModalOpen] = useState(false);
    const [gpModalTitle, setGpModalTitle] = useState("");
    const [gpData, setGpData] = useState([]);
    const [gpLoading, setGpLoading] = useState(false);
    const [selectedBlock, setSelectedBlock] = useState(null);


    const numberSorter = (a, b, key) => {
        const valA = a[key] || 0;
        const valB = b[key] || 0;
        return valA - valB;
    };

    // Helper function for string sorting
    const stringSorter = (a, b, key) => {
        const valA = (a[key] || '').toString().toLowerCase();
        const valB = (b[key] || '').toString().toLowerCase();
        return valA.localeCompare(valB);
    };


    /* ================= MAIN TABLE COLUMNS ================= */
    const columns = [
        {
            title: "Sr. No.",
            dataIndex: "sr_no",
            key: "sr_no",
            width: 60,
            align: "center",
            fixed: "left",
            sorter: (a, b) => numberSorter(a, b, 'sr_no'),
        },
        {
            title: "District Name",
            dataIndex: "district_name",
            key: "district_name",
            width: 160,
            align: "center",
            sorter: (a, b) => stringSorter(a, b, 'district_name'),
            ellipsis: true,
        },
        {
            title: "Block Name",
            dataIndex: "block_name",
            key: "block_name",
            width: 180,
            align: "center",
            sorter: (a, b) => stringSorter(a, b, 'block_name'),
            ellipsis: true,
        },
        {
            title: "No. of Gram Panchayats",
            dataIndex: "gp_count",
            key: "gp_count",
            width: 160,
            align: "center",
            sorter: (a, b) => numberSorter(a, b, 'gp_count'),
            render: (val, record) => (
                <span
                    onClick={() => openGPFromBlock(record)}
                    style={clickStyle}
                >
                    {val || 0}
                </span>
            ),
            sorter: (a, b) => (a.gp_count || 0) - (b.gp_count || 0),
        },
        {
            title: "Gram Sabha Held (including 1st,2nd & 3rd)",
            dataIndex: "gram_sabha_held",
            key: "gram_sabha_held",
            width: 140,
            align: "center",
            sorter: (a, b) => numberSorter(a, b, 'gram_sabha_held'),
            render: (val) => <span>{val || 0}</span>,

        },
        {
            title: "Quorum Fulfilled (including 1st,2nd & 3rd meeting)",
            dataIndex: "quorum_fulfilled",
            key: "quorum_fulfilled",
            width: 130,
            align: "center",
            render: (val) => <span>{val || 0}</span>,
            sorter: (a, b) => numberSorter(a, b, 'quorum_fulfilled'),
        },
        {
            title: "Quorum Failed (including 1st,2nd & 3rd meeting)",
            dataIndex: "quorum_failed",
            key: "quorum_failed",
            width: 120,
            align: "center",
            render: (val) => <span>{val || 0}</span>,
            sorter: (a, b) => numberSorter(a, b, 'quorum_failed'),
        },
        {
            title: "Never Scheduled Gram Sabha",
            dataIndex: "never_scheduled_gs",
            key: "never_scheduled_gs",
            width: 140,
            align: "center",
            render: (val) => <span>{val || 0}</span>,
            sorter: (a, b) => numberSorter(a, b, 'never_scheduled_gs'),
        },
    ];

    /* ================= GP MODAL COLUMNS ================= */
    const gpColumns = [
        {
            title: "Sr. No.",
            dataIndex: "sr_no",
            key: "sr_no",
            width: 60,
            align: "center",
            fixed: "left",
            sorter: (a, b) => numberSorter(a, b, 'sr_no'),
        },
        {
            title: "District Name",
            dataIndex: "district_name",
            width: 140,
            align: "center",
            fixed: "left",
            sorter: (a, b) => stringSorter(a, b, 'district_name'),
        },
        {
            title: "Block Name",
            dataIndex: "block_name",
            width: 160,
            align: "center",
            fixed: "left",
            sorter: (a, b) => stringSorter(a, b, 'block_name'),
        },
        {
            title: "Gram Panchayat Name",
            dataIndex: "gp_name",
            width: 200,
            align: "center",
            fixed: "left",
            sorter: (a, b) => stringSorter(a, b, 'gp_name'),
        },
        {
            title: "Gram Sabha Held (including 1st,2nd & 3rd)",
            dataIndex: "gram_sabha_held",
            width: 120,
            align: "center",
            sorter: (a, b) => numberSorter(a, b, 'gram_sabha_held'),
            render: (val) => <span>{val || 0}</span>,
        },
        {
            title: "Quorum Fulfilled (including 1st,2nd & 3rd meeting)",
            dataIndex: "quorum_fulfilled",
            width: 120,
            align: "center",
            sorter: (a, b) => numberSorter(a, b, 'quorum_fulfilled'),
            render: (val) => <span>{val || 0}</span>,
        },
        {
            title: "Quorum Failed (including 1st,2nd & 3rd meeting)",
            dataIndex: "quorum_failed",
            width: 110,
            align: "center",
            sorter: (a, b) => numberSorter(a, b, 'quorum_failed'),
            render: (val) => <span>{val || 0}</span>,
        },
        {
            title: "Never Scheduled Gram Sabha",
            dataIndex: "never_scheduled_gs",
            width: 130,
            align: "center",
            sorter: (a, b) => numberSorter(a, b, 'never_scheduled_gs'),
            render: (val) => <span>{val || 0}</span>,
        },
    ];

    const fetchReportData = async () => {
        try {
            setLoading(true);
            setError(null);

            const token = sessionStorage.getItem("token");

            if (!token) {
                setError("No authentication token found. Please login again.");
                message.error("Authentication required");
                return;
            }

            console.log("Fetching admin block report...");

            const res = await getBdpoBlockSpecialGsReport(token, dateFilter);

            console.log("Full API Response:", res);
            const reportData = res.result || [];

            const formatted = reportData.map((item, index) => {
                return {
                    ...item,
                    key: item.block_code || `block-${index}`,
                    sr_no: index + 1,
                    gp_count: item.gp_count || item.no_of_gram_panchayats || 0,
                    gram_sabha_held: item.gram_sabha_held || item.total_panchayats_gramsabha_held || 0,
                    quorum_fulfilled: item.quorum_fulfilled || item.quorum_fulfilled_count || 0,
                    quorum_failed: item.quorum_failed || item.quorum_failed_count || 0,
                    never_scheduled_gs: item.never_scheduled_gs || item.never_scheduled_gramsabha || 0,
                    district_code: item.district_code,
                };
            });

            setData(formatted);

            if (formatted.length > 0) {
                message.success(`Loaded ${formatted.length} block records`);
            } else {
                message.warning("No block data found");
            }

        } catch (err) {
            console.error("Fetch Error Details:", err);
            const errorMsg = err.message || "Failed to fetch report data";
            setError(errorMsg);
            message.error(errorMsg);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchReportData();
    }, [dateFilter]);

    /* ================= DRILL FUNCTIONS ================= */
    const openGPFromBlock = async (block) => {
        console.log('Opening GP modal for block:', block.block_name);
        setSelectedBlock(block);
        setGpModalTitle(`Gram Panchayat-wise Report : ${block.block_name} (${block.district_name})`);
        setGpModalOpen(true);
        setGpData([]);
        setGpLoading(true);

        try {
            const token = sessionStorage.getItem("token");

            if (!token) {
                message.error("No authentication token found");
                setGpLoading(false);
                return;
            }

            // नया API फंक्शन इस्तेमाल करें (district_code + block_code दोनों पास करें)
            const result = await getAdminGpSummaryReport(token, block.district_code, block.block_code);

            if (result.success) {
                const gpFormatted = result.result.map((item, index) => ({
                    ...item,
                    key: item.panchayat_code || `gp-${index}`,
                    sr_no: index + 1,
                    district_name: item.district_name || block.district_name,
                    block_name: item.block_name || block.block_name,
                    gp_name: item.panchayat_name || item.gp_name || "N/A",
                    gram_sabha_held: item.total_panchayats_gramsabha_held || 0,
                    quorum_fulfilled: item.quorum_fulfilled_count || 0,
                    quorum_failed: item.quorum_failed_count || 0,
                    never_scheduled_gs: item.never_scheduled_gramsabha || 0,
                    block_code: item.block_code,
                    panchayat_code: item.panchayat_code,
                }));

                setGpData(gpFormatted);
                message.success(`Loaded ${gpFormatted.length} gram panchayats for ${block.block_name}`);
            } else {
                message.error(result.message || 'Failed to fetch GP data');
            }
        } catch (err) {
            console.error('Error fetching GP data:', err);
            message.error(err.message || 'Failed to fetch GP data. Please try again.');
        } finally {
            setGpLoading(false);
        }
    };
    const handleTableChange = (pagination) => {
        setCurrentPage(pagination.current);
        setPageSize(pagination.pageSize);
    };

    /* ================= EXPORT FUNCTIONS ================= */
    const handleExportPDF = () => {
        if (!data.length) {
            message.warning("No data to export");
            return;
        }

        try {
            const doc = new jsPDF("landscape");

            // Title
            doc.setFontSize(18);
            doc.setTextColor(40, 40, 40);
            doc.text("Block-wise Status of Special Gram Sabha", 105, 20, { align: 'center' });

            // Table data prepare
            const tableColumn = columns.map(col => col.title);
            const tableRows = data.map(row =>
                columns.map(col => {
                    const val = row[col.dataIndex];
                    if (val === null || val === undefined) return '';
                    return String(val);
                })
            );

            // Create table
            autoTable(doc, {
                head: [tableColumn],
                body: tableRows,
                startY: 30,
                theme: 'grid',
                headStyles: {
                    fillColor: [22, 119, 255],
                    textColor: 255,
                    fontStyle: 'bold'
                },
                styles: {
                    fontSize: 9,
                    cellPadding: 2,
                    overflow: 'linebreak'
                },
                alternateRowStyles: {
                    fillColor: [245, 245, 245]
                },
                margin: { top: 30 }
            });

            doc.save(`Block_Special_GS_Report_${new Date().toISOString().split('T')[0]}.pdf`);
            message.success("PDF exported successfully");
        } catch (err) {
            console.error("PDF Export Error:", err);
            message.error("Failed to export PDF: " + err.message);
        }
    };

    const handleExportExcel = () => {
        if (!data.length) {
            message.warning("No data to export");
            return;
        }

        try {
            const excelData = data.map((row, idx) => ({
                "Sr. No.": idx + 1,
                "District Name": row.district_name || "-",
                "Block Name": row.block_name || "-",
                "No. of Gram Panchayats": row.gp_count || 0,
                "Gram Sabha Held (including 1st,2nd & 3rd)": row.gram_sabha_held || 0,
                "Quorum Fulfilled (including 1st, 2nd & 3rd)": row.quorum_fulfilled || 0,
                "Quorum Failed (including 1st, 2nd & 3rd)": row.quorum_failed || 0,
                "Never Scheduled Gram Sabha": row.never_scheduled_gs || 0,
            }));
            excelData.push({
                "Sr. No.": "GRAND TOTAL",
                "District Name": "",
                "Block Name": "",
                "No. of Gram Panchayats": grandTotals.gp_count,
                "Gram Sabha Held (including 1st,2nd & 3rd)": grandTotals.gram_sabha_held,
                "Quorum Fulfilled (including 1st, 2nd & 3rd)": grandTotals.quorum_fulfilled,
                "Quorum Failed (including 1st, 2nd & 3rd)": grandTotals.quorum_failed,
                "Never Scheduled Gram Sabha": grandTotals.never_scheduled_gs,
            });

            const worksheet = XLSX.utils.json_to_sheet(excelData);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Block Report");

            const fileName = `Block_Special_GS_Report_${new Date().toISOString().split('T')[0]}.xlsx`;
            XLSX.writeFile(workbook, fileName);
            message.success("Excel file exported successfully");
        } catch (err) {
            console.error("Excel Export Error:", err);
            message.error("Failed to export Excel");
        }
    };

    const handleExportGpExcel = () => {
        if (!gpData.length) return message.warning("No data to export");

        try {
            const excelData = gpData.map((row, idx) => ({
                "Sr. No.": idx + 1,
                "District Name": row.district_name || "-",
                "Block Name": row.block_name || "-",
                "Gram Panchayat Name": row.gp_name || "-",
                "Gram Sabha Held (including 1st, 2nd & 3rd)": row.gram_sabha_held || 0,
                "Quorum Fulfilled (including 1st, 2nd & 3rd)": row.quorum_fulfilled || 0,
                "Quorum Failed (including 1st, 2nd & 3rd)": row.quorum_failed || 0,
                "Never Scheduled Gram Sabha": row.never_scheduled_gs || 0,

            }));

            excelData.push({
                "Sr. No.": "GRAND TOTAL",
                "District Name": "",
                "Block Name": "",
                "Gram Panchayat Name": "",
                "Gram Sabha Held (including 1st, 2nd & 3rd)": gpGrandTotals.gram_sabha_held,
                "Quorum Fulfilled (including 1st, 2nd & 3rd)": gpGrandTotals.quorum_fulfilled,
                "Quorum Failed (including 1st, 2nd & 3rd)": gpGrandTotals.quorum_failed,
                "Never Scheduled Gram Sabha": gpGrandTotals.never_scheduled_gs,
            });


            const worksheet = XLSX.utils.json_to_sheet(excelData);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "GP Report");

            const fileName = `GP_Report_${selectedBlock?.block_name?.replace(/\s+/g, '_') || 'Block'}_${new Date().toISOString().split('T')[0]}.xlsx`;
            XLSX.writeFile(workbook, fileName);
            message.success("GP Excel file exported successfully");
        } catch (err) {
            console.error("GP Excel Export Error:", err);
            message.error("Failed to export GP Excel");
        }
    };

    /* ================= CLICK STYLE ================= */
    const clickStyle = {
        color: "#1677ff",
        cursor: "pointer",
        textDecoration: "underline",
        fontWeight: 500,
    };
    const grandTotals = {
        gp_count: data.reduce((s, i) => s + (i.gp_count || 0), 0),
        gram_sabha_held: data.reduce((s, i) => s + (i.gram_sabha_held || 0), 0),
        quorum_fulfilled: data.reduce((s, i) => s + (i.quorum_fulfilled || 0), 0),
        quorum_failed: data.reduce((s, i) => s + (i.quorum_failed || 0), 0),
        never_scheduled_gs: data.reduce((s, i) => s + (i.never_scheduled_gs || 0), 0),
    };

    const gpGrandTotals = {
        gram_sabha_held: gpData.reduce((s, i) => s + (i.gram_sabha_held || 0), 0),
        quorum_fulfilled: gpData.reduce((s, i) => s + (i.quorum_fulfilled || 0), 0),
        quorum_failed: gpData.reduce((s, i) => s + (i.quorum_failed || 0), 0),
        never_scheduled_gs: gpData.reduce((s, i) => s + (i.never_scheduled_gs || 0), 0),
    };


    return (
        <div className="report-container">
            <div style={{
                background: '#fff',
                padding: '24px',
                borderRadius: '8px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
                marginBottom: '24px'
            }}>
                <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: '20px'
                }}>
                    <div>
                        <h2 style={{
                            fontSize: '20px',
                            fontWeight: '600',
                            marginBottom: '4px',
                            color: '#1f1f1f'
                        }}>
                            Block-wise Status of Special Gram Sabha
                        </h2>
                        <p style={{
                            fontSize: '14px',
                            color: '#666',
                            margin: 0
                        }}>
                            Total Records: <strong>{data.length}</strong>
                        </p>
                    </div>

                    <Space>
                        {/* <Button
                            icon={<FilePdfOutlined />}
                            onClick={handleExportPDF}
                            disabled={loading || data.length === 0}
                        >
                            Export PDF
                        </Button> */}
                        <Button
                            type="primary"
                            icon={<FileExcelOutlined />}
                            onClick={handleExportExcel}
                            disabled={loading || data.length === 0}
                        >
                            Export Excel
                        </Button>
                        <Button
                            icon={<ReloadOutlined />}
                            onClick={fetchReportData}
                            disabled={loading}
                        >
                            Refresh
                        </Button>
                    </Space>
                </div>

                {error && (
                    <Alert
                        message={error}
                        type="error"
                        showIcon
                        style={{ marginBottom: '16px' }}
                    />
                )}

                {loading ? (
                    <div style={{ textAlign: 'center', padding: '50px' }}>
                        <Spin size="large" />
                        <p style={{ marginTop: '10px', color: '#666' }}>Loading block report data...</p>
                    </div>
                ) : (
                    <Table
                        columns={columns}
                        dataSource={data}
                        rowKey="key"
                        bordered
                        size="small"
                        scroll={{ x: 1200, y: 420 }}
                        pagination={{
                            current: currentPage,
                            pageSize: pageSize,
                            total: data.length,
                            showSizeChanger: true,
                            // showQuickJumper: true,
                            showTotal: (total, range) =>
                                `${range[0]}-${range[1]} of ${total} records`,
                            pageSizeOptions: ['10', '20', '50', '100'],
                        }}
                        onChange={handleTableChange}
                    />

                )}
                {data.length > 0 && (
                    <div
                        style={{
                            marginTop: 12,
                            padding: "10px 14px",
                            background: "#e6f7ff",
                            border: "1px solid #91d5ff",
                            borderRadius: 6,
                            display: "flex",
                            flexWrap: "wrap",
                            gap: 14,
                            fontSize: 13,
                        }}
                    >
                        <span><strong>Grand Totals (All Pages):</strong></span>
                        <span>GPs: <strong>{grandTotals.gp_count}</strong></span>
                        <span>GS Held: <strong>{grandTotals.gram_sabha_held}</strong></span>
                        <span>Quorum Met: <strong>{grandTotals.quorum_fulfilled}</strong></span>
                        <span>Quorum Failed: <strong>{grandTotals.quorum_failed}</strong></span>
                        <span>Never Scheduled: <strong>{grandTotals.never_scheduled_gs}</strong></span>
                    </div>
                )}

            </div>

            {/* ========== GP MODAL ========== */}

            {/* ========== GP MODAL ========== */}
            <Modal
                open={gpModalOpen}
                onCancel={() => setGpModalOpen(false)}
                width={1200}
                destroyOnClose
                footer={null}
                closable
                style={{ top: 20 }}
                bodyStyle={{
                    padding: '16px 0 0 0',
                    overflow: 'hidden'
                }}
                title={
                    <div style={{ paddingRight: 40 }}>
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                            }}
                        >
                            <span style={{ fontSize: "16px", fontWeight: "600", color: "#1f1f1f" }}>
                                {gpModalTitle}
                            </span>

                            <Button
                                type="primary"
                                icon={<FileExcelOutlined />}
                                onClick={handleExportGpExcel}
                                disabled={gpLoading || gpData.length === 0}
                                style={{ fontWeight: 500 }}
                            >
                                Export Excel
                            </Button>
                        </div>
                    </div>
                }
            >
                {gpLoading ? (
                    <div style={{ textAlign: "center", padding: "40px" }}>
                        <Spin size="large" />
                        <p style={{ marginTop: 10, color: "#666", fontWeight: 500 }}>
                            Loading Gram Panchayat data...
                        </p>
                    </div>
                ) : gpData.length === 0 ? (
                    <div style={{ textAlign: "center", padding: "40px", color: "#999" }}>
                        <Alert
                            message={<span style={{ fontWeight: 600 }}>No Data Available</span>}
                            description={
                                <span style={{ fontWeight: 500 }}>
                                    No Gram Panchayat data found for {selectedBlock?.block_name}.
                                    This block may not have any Gram Panchayats assigned or data is not available.
                                </span>
                            }
                            type="info"
                            showIcon
                        />
                    </div>
                ) : (
                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        height: 'calc(80vh - 110px)',
                        overflow: 'hidden'
                    }}>
                        <div style={{
                            flex: 1,
                            overflowY: 'auto',
                            overflowX: 'hidden',
                            paddingRight: '4px'
                        }}>
                            <Table
                                columns={gpColumns}
                                dataSource={gpData}
                                rowKey="key"
                                bordered
                                size="small"
                                scroll={{
                                    x: 900,
                                    y: undefined
                                }}
                                pagination={{
                                    current: gpCurrentPage,
                                    pageSize: gpPageSize,
                                    total: gpData.length,
                                    showSizeChanger: true,
                                    pageSizeOptions: ["10", "20", "50", "100"],
                                    showTotal: (total, range) =>
                                        `${range[0]}-${range[1]} of ${total} records`,
                                }}
                                onChange={(pagination) => {
                                    setGpCurrentPage(pagination.current);
                                    setGpPageSize(pagination.pageSize);
                                }}
                            />
                        </div>

                        {/* 🔽 TOTAL STRIP BELOW TABLE */}
                        <div
                            style={{
                                marginTop: 10,
                                padding: "10px 14px",
                                background: "#f0f9ff",
                                borderRadius: 6,
                                border: "1px solid #bae0ff",
                                display: "flex",
                                flexWrap: "wrap",
                                gap: 14,
                                fontSize: 13,
                                flexShrink: 0
                            }}
                        >
                            <span><strong>Grand Totals (All Pages):</strong></span>
                            <span>GPs: <strong>{gpData.length}</strong></span>
                            <span>GS Held: <strong>{gpGrandTotals.gram_sabha_held}</strong></span>
                            <span>Quorum Met: <strong>{gpGrandTotals.quorum_fulfilled}</strong></span>
                            <span>Quorum Failed: <strong>{gpGrandTotals.quorum_failed}</strong></span>
                            <span>Never Scheduled: <strong>{gpGrandTotals.never_scheduled_gs}</strong></span>
                        </div>

                    </div>
                )}
            </Modal>

        </div>
    );
};

export default DistrictBDPOReport;